import React, { useState, useEffect } from 'react';

const GA_TRACKING_ID = 'G-3LBGZ5T1DZ';

// Helper function to inject the Google Analytics script
const initGA = () => {
  if (document.querySelector(`script[src*="${GA_TRACKING_ID}"]`)) {
    return;
  }
  
  const script1 = document.createElement('script');
  script1.src = `https://www.googletagmanager.com/gtag/js?id=${GA_TRACKING_ID}`;
  script1.async = true;
  document.head.appendChild(script1);

  const script2 = document.createElement('script');
  script2.innerHTML = `
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());
    gtag('config', '${GA_TRACKING_ID}');
  `;
  document.head.appendChild(script2);
};

// Helper function to remove GA cookies
const removeGA = () => {
  // Clear any existing GA cookies
  const cookies = document.cookie.split('; ');
  for (const cookie of cookies) {
    const [name] = cookie.split('=');
    if (name.startsWith('_ga') || name.startsWith('_gid')) {
      document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
    }
  }
};


const CookieConsent = () => {
  const [showBanner, setShowBanner] = useState(false);
  const [hasMadeChoice, setHasMadeChoice] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookie_consent');
    if (consent === 'true') {
      initGA();
      setHasMadeChoice(true);
    } else if (consent === 'false') {
      setHasMadeChoice(true);
    } else {
      setShowBanner(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookie_consent', 'true');
    initGA();
    setShowBanner(false);
    setHasMadeChoice(true);
  };

  const handleDecline = () => {
    localStorage.setItem('cookie_consent', 'false');
    removeGA();
    setShowBanner(false);
    setHasMadeChoice(true);
  };

  const handleManageSettings = () => {
    localStorage.removeItem('cookie_consent');
    window.location.reload();
  };

  if (showBanner) {
    return (
      <div className="fixed bottom-0 left-0 right-0 bg-dark-lighter p-4 text-white z-50 shadow-lg md:flex md:items-center md:justify-between">
        <p className="text-sm md:mr-4">
          This website uses cookies to improve your experience. Some are essential for the functionality of this website. By clicking "Accept", you agree to our use of analytics cookies.
        </p>
        <div className="flex items-center mt-4 md:mt-0">
          <button
            onClick={handleAccept}
            className="bg-primary hover:bg-primary-dark text-white font-bold py-2 px-4 rounded-lg text-sm"
          >
            Accept
          </button>
          <button
            onClick={handleDecline}
            className="ml-4 text-gray-400 hover:text-white font-bold py-2 px-4 rounded-lg text-sm"
          >
            Decline
          </button>
        </div>
      </div>
    );
  }

  if (hasMadeChoice) {
    return (
      <button 
        onClick={handleManageSettings}
        className="fixed bottom-4 right-4 bg-primary text-white p-3 rounded-full shadow-lg z-50"
        aria-label="Manage cookie settings"
      >
        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
          <path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
          <path strokeLinecap="round" strokeLinejoin="round" d="M12 21a9 9 0 100-18 9 9 0 000 18z" />
        </svg>
      </button>
    );
  }

  return null;
};

export default CookieConsent; 